import React from "react";
import EmployeeThumbs from "./Images/Employees/EmployeeThumbs";
import { useTranslation } from "react-i18next";

const Intro = () => {
  const { t } = useTranslation();

  return (
    <div className="intro flex-initial">
      <EmployeeThumbs />
      <h1 className=" text-3xl font-medium font-sans mb-1">
        {t("INTRO.WELCOME_TO")}{" "}
        <span className="text-blue-600 font-bold">CMC</span> 👋
      </h1>
      <span className="block mb-10 leading-5">{t("INTRO.WHO_IS_CMC")}</span>
    </div>
  );
};

export default Intro;
